import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

/**
 * DashboardDatagrid
 * - A thin wrapper around MUI DataGridPremium that applies dashboard-friendly styles (sx)
 * - Focus is on styling only; cell renderers and rows are passed through via props
 */
const DashboardDatagrid = ({
  sx = {},
  disableColumnMenu = true,
  rows = [],
  ...props
}) => {
  const baseSx = {
    borderRadius: 2,
    border: 0,
    bgcolor: 'transparent',
  };

  return (
    <Box sx={{ width: '100%', height: '400px', ...sx }}>
      <DataGridPremium
        {...props}
        rows={rows}
        disableColumnMenu={disableColumnMenu}
        density="compact"
        hideFooter
        sx={baseSx}
      />
    </Box>
  );
};

export default DashboardDatagrid;
